export default "__VITE_ASSET__LTb7reEW__"